import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';
import * as mathjs from 'mathjs';

/** Balance report custom row create or update request body */
export interface BalanceReportCustomRowFormInterface {
  /** Row display name */
  name: string;
  /** Row expression */
  expression: string;
  /** Row measure to display */
  measure?: string;
  /** Row custom color */
  color?: string;
}

/** Balance report custom row create or update request body - DTO schema */
export const BalanceReportCustomRowFormDto = SerdeDtoClass.create<BalanceReportCustomRowFormInterface>(FinanceDtoKeysEnum.BALANCE_REPORT_CUSTOM_ROW_FORM_DTO, {
  name: {
    label: 'Название',
    hint: 'Название этой строки в ОПиУ',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  expression: {
    label: 'Формула',
    hint: 'Математическая формула, по которой вычисляются значения этой строки в ОПиУ',
    serializer: () => yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING)
      .test({
        name: 'balance-custom-row-expression-validator',
        test: (value, yupContext) => {
          yupContext.parent
          try {
            mathjs.compile(value)
            return true;
          } catch (error) {
            return yupContext.createError({ message: `Неправильно составленное выражение (${error.char} символ): ${error.message}` });
          }
        },
      }),
  },
  measure: {
    label: 'Единица измерения',
    hint: 'Суффикс, отображающий единицу измерения (например, "%"). Будет показан после вычисленного значения.',
    optional: true,
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет строки',
    hint: 'Специальный цвет, которым нужно подсветить эту строку',
    optional: true,
    serializer: hexColorSchema,
  },
});
